import {
  getGridStringOperators,
  GridFilterItem,
  GridSortModel,
} from '@mui/x-data-grid-pro';
import {
  IssueState,
  GridColumnFieldIssue,
} from 'components/common/dataGrid/columnsFactory/types';
import { GridFilterValue } from 'components/common/dataGrid/filters/operators';
import { Color } from 'shared/utils/colors';
import { LastDecisionStatus } from 'shared/domain/workflow/lastDecisionStatus';

export { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from 'components/common/dataGrid/constants';

export const DEFAULT_ISSUE_STATE_FILTER_ITEM: GridFilterItem = {
  id: 'issue-required-state-filter',
  field: GridColumnFieldIssue.state,
  operator: 'is',
  value: IssueState.published,
};

export const INITIAL_SORT_MODEL: GridSortModel = [
  { field: 'modifiedAt', sort: 'desc' },
];

export const DEFAULT_VISIBLE_ISSUE_COLUMNS: string[] = [
  'orderNumber',
  'process',
  'issueNumber',
  'inspectionNumber',
  'title',
  'stage',
  'sites',
  'levels',
  'createdAt',
  'modifiedAt',
  'finalCompletionDate',
  'state',
];

const ALL_ISSUE_COLUMN_FIELDS: string[] = Object.values(GridColumnFieldIssue);

export const ISSUE_INITIAL_COLUMN_VISIBILITY_MODEL: Record<string, boolean> =
  Object.fromEntries(
    ALL_ISSUE_COLUMN_FIELDS.map((field) => [
      field,
      DEFAULT_VISIBLE_ISSUE_COLUMNS.includes(field),
    ])
  );

export const GRID_STRING_FILTER_OPERATORS = getGridStringOperators();

export const ISSUE_NUMBER_FILTER_OPERATORS = GRID_STRING_FILTER_OPERATORS.filter(
  (operator) =>
    operator.value !== GridFilterValue.IS_EMPTY &&
    operator.value !== GridFilterValue.IS_NOT_EMPTY
);

export const ISSUE_DEADLINE_CLASS = {
  green: 'issue-grid-cell--deadline-green',
  yellow: 'issue-grid-cell--deadline-yellow',
  orange: 'issue-grid-cell--deadline-orange',
  red: 'issue-grid-cell--deadline-red',
} as const;

export const ISSUE_DELAY_CLASS = {
  red: 'issue-grid-cell--delay-red',
} as const;

export const ISSUE_PERCENTAGE_COLOR_BY_LEVEL = {
  green: 'success.main',
  yellow: 'warning.main',
  red: 'error.main',
} as const;

export const LAST_DECISION_STATUS_COLOR: Partial<Record<LastDecisionStatus, Color>> = {
  [LastDecisionStatus.APPROVED]: Color.accentGreen600,
  [LastDecisionStatus.REJECTED]: Color.red,
};

export const NUMBER_COLUMN_OPTIONS = {
  type: 'number',
} as const;

export const NUMBER_COLUMN_TEXT_LIKE_ALIGNMENT_OPTIONS = {
  align: 'left',
  headerAlign: 'left',
} as const;

export const FILTERABLE_TEXT_COLUMN_OPTIONS = {
  filterable: true,
} as const;

export const FILTERABLE_NUMBER_COLUMN_OPTIONS = {
  ...NUMBER_COLUMN_OPTIONS,
  filterable: true,
  filterOperators: GRID_STRING_FILTER_OPERATORS,
} as const;
